<template>

<router-view />

</template>

<script>
export default {
    name: 'admin',
    created() {
        if (!this.getAdministratorFlag) {
          this.$router.push('/')
        }
    }
}
</script>

<style>

</style>
